/**
 * Form Engine — barrel export
 * 
 * Central export for computed fields engine, rules engine,
 * and any future form processing utilities.
 */

export {
  evaluateComputedFields,
  type ComputedFieldDef,
  type ComputedFieldResult,
} from './computedFields';

export {
  evaluateRules,
  resolveBranchingHiddenSections,
  type RuleDef,
  type RuleAction,
  type RuleResult,
  type RulesEvaluationResult,
  type BranchingSection,
} from './rulesEngine';

export {
  validateFieldValue,
  collectFieldValidationErrors,
  collectMissingRequiredFields,
  isEmptyValue,
  type FieldValidationResult,
  type FieldValidationRule,
} from './fieldValidation';
